import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators as bindActions } from "redux";
import cx from "classnames";
//
import Screen from "./ConnectedScreen";

class VerifyPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      password: "",
    };
  }

  enterSubmit = (ev) => {
    if (ev.key === "Enter") {
      this.onSubmit();
    }
  };

  onSubmit = () => {
    const { password } = this.state;
    const { email, verifyPassword } = this.props;

    if (password && password.length > 5) {
      verifyPassword({ email, password });
    } else {
      this.setState({ error: true });
    }
  };

  onChangePassword = (ev) => {
    this.setState({
      password: ev.target.value,
      error: false,
    });
  };

  render() {
    const { email, errorMessage } = this.props;
    const { password, error } = this.state;

    return (
      <Screen
        title="Password required"
        isActive
        className="screen--password form"
        nextLabel="Submit"
        onBack={false}
        onNext={this.onSubmit}
      >
        <p>
          This account <span className="u-brand">{email}</span> is protected by
          a password.
        </p>
        <br />
        <div className={cx("form__field", { error })}>
          <label>Enter password</label>
          <input
            type="password"
            name="password"
            value={password}
            className="form__control"
            onChange={this.onChangePassword}
            autoFocus
            onKeyDown={this.enterSubmit}
          />
          {error && (
            <small className="form__error">
              Password is at least 6 characters long
            </small>
          )}
        </div>
        {errorMessage !== null && (
          <p className="u-danger u-small u-mv">{errorMessage}</p>
        )}
      </Screen>
    );
  }
}

// @connect
import { verifyPasswordAction } from "../modules/booking/actions";

const state = ({ booking }) => ({
  email: booking.email,
});

const actions = (dispatch) =>
  bindActions({ verifyPassword: verifyPasswordAction }, dispatch);

export default connect(
  state,
  actions
)(VerifyPassword);
